export const promptGuide = {
  intro:
    "The prompt defines your bot's personality, knowledge, and behavior. Write clear instructions about:",
  bullets: [
    "Who the bot is (role, personality, tone)",
    "What the bot knows (expertise, domain knowledge)",
    "How the bot should respond (style, format, limitations)",
    "Any specific rules or guidelines to follow",
  ],
  important:
    'Don\'t include time-sensitive tasks or recurring actions (like "send daily reports" or "remind me every week").',
  closing:
    "Be specific and detailed - the more context you provide, the better your bot will perform.",
} as const;

export const promptSecurityNote =
  "Never include passwords, API keys, or sensitive information in your bot's prompt. The prompt and all bot actions should be considered potentially accessible to others. Only include information you're comfortable sharing publicly." as const;

export const statelessPromptGuide = {
  title: "What is a stateless prompt?",
  summary:
    "A bot prompt defines static identity, knowledge, and rules. It cannot contain dynamic state or scheduled jobs that run outside active chat.",
  rules: [
    "No scheduled or recurring tasks (e.g. 'send a daily reminder at 9am') — configure those under the Scheduled Tasks tab or ask the AI builder.",
    "No running lists or tallies to update during conversations — store data externally using tools like Google Sheets or a database.",
    "No instructions to modify or rewrite the prompt itself over time.",
  ],
} as const;
